import { InspectorControls } from '@wordpress/block-editor';
import {
	PanelBody,
	RangeControl,
	ToggleControl,
	__experimentalUnitControl as UnitControl,
} from '@wordpress/components';
import { __ } from '@wordpress/i18n';
import { useSelect } from '@wordpress/data';
import metadata from '../../block.json';
import NavigationControls from './navigation-controls';
import PaginationControls from './pagination-controls';
import ColorsControls from './colors-controls';
import CarouselSettings from './carousel-settings';
import QueryControls from './query-controls';
import EffectControl from './effect-control';

export default function AllInspectorSettings( props ) {
	const { attributes, setAttributes } = props;
	const isDynamic = attributes.isDynamic ?? false;

	const previewDevice = useSelect(
		( select ) =>
			(
				(
					select( 'core/edit-post' ) ?? select( 'core/edit-site' )
				)?.__experimentalGetPreviewDeviceType() ?? 'Desktop'
			).toLowerCase(),
		[]
	);

	const device = previewDevice || 'desktop';

	const handleChangeSlidesPerView = ( value ) => {
		setAttributes( {
			slides: {
				...attributes.slides,
				[ device ]: value,
			},
		} );
	};

	const slides =
		attributes.slides[ device ] ??
		metadata.attributes.slides.default[ device ];

	return (
		<>
			<InspectorControls>
				<PanelBody title={ __( 'Settings', 'brandy-blocks' ) }>
					<ToggleControl
						__nextHasNoMarginBottom
						label={ __( 'Dynamic content', 'brandy-blocks' ) }
						help={
							isDynamic
								? __(
										'Slides are populated from queried posts.',
										'brandy-blocks'
								  )
								: __(
										'Slides are manually added.',
										'brandy-blocks'
								  )
						}
						checked={ isDynamic }
						onChange={ ( v ) =>
							setAttributes( { isDynamic: v } )
						}
					/>
					<RangeControl
						__nextHasNoMarginBottom
						label={ __( 'Slides per view', 'brandy-blocks' ) }
						value={ slides }
						onChange={ handleChangeSlidesPerView }
						min={ 1 }
						max={ 6 }
					/>
					<UnitControl
						label={ __( 'Slides spacing', 'brandy-blocks' ) }
						onChange={ ( v ) =>
							setAttributes( { itemsSpacing: v } )
						}
						value={ attributes.itemsSpacing ?? '24px' }
					/>
					<NavigationControls { ...props } />
					<PaginationControls { ...props } />
					<EffectControl { ...props } />
				</PanelBody>
				{ isDynamic && <QueryControls { ...props } /> }
				<CarouselSettings { ...props } />
			</InspectorControls>
			{ ( ( attributes.navigation?.enabled ?? true ) ||
				( attributes.pagination?.enabled ?? true ) ) && (
				<InspectorControls group="styles">
					<ColorsControls { ...props } />
				</InspectorControls>
			) }
		</>
	);
}
